import { useState } from 'react';
import { List, BarChart3 } from 'lucide-react';
import MonthlyRoster from './MonthlyRoster';
import TechMetrics from './TechMetrics';

const tabs = [
  { id: 'roster', label: 'Monthly Roster', icon: List },
  { id: 'metrics', label: 'Tech Metrics', icon: BarChart3 },
];

export default function Reports() {
  const [activeTab, setActiveTab] = useState('roster');

  return (
    <div className="h-full flex flex-col">
      <div className="hub-page-header">
        <h1>Reports</h1>
        <p>Monthly completion roster and technician performance metrics</p>
        <div className="mt-3 flex gap-1">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={isActive ? 'hub-segment-tab-active' : 'hub-segment-tab-inactive'}
              >
                <Icon className="h-3.5 w-3.5 mr-1.5 inline" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
      <div className="flex-1 overflow-auto">
        {activeTab === 'roster' ? <MonthlyRoster embedded /> : <TechMetrics embedded />}
      </div>
    </div>
  );
}
